/**
 * Badge colorato per lo stato di una richiesta di preventivo (RDP).
 * Usa solo classi Tailwind dal design system.
 */

import React from 'react';

interface StatoRichiestaBadgeProps {
  stato: string;
}

const STATI: Record<string, { label: string; className: string }> = {
  bozza: { label: 'Bozza', className: 'bg-muted text-muted-foreground' },
  inviata: { label: 'Inviata', className: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300' },
  parzialmente_risposta: { label: 'Parziale', className: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300' },
  completata: { label: 'Completata', className: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300' },
  annullata: { label: 'Annullata', className: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300' },
};

export function StatoRichiestaBadge({ stato }: StatoRichiestaBadgeProps) {
  const config = STATI[stato] ?? { label: stato, className: 'bg-muted text-muted-foreground' };

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${config.className}`}
    >
      {config.label}
    </span>
  );
}
